import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const MentionRateTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>
                        How often a brand is mentioned in relation to <br />
                        all LLM responses. Only applies to responses from <br />
                        organic prompts.
                  </p>
            </BaseTooltip>
      );
};
